module.exports = __webpack_public_path__ + "media/images/Arrow-Right-b67d3c13.svg";